// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"46165f93","239":"603d23f7","667":"8733d0ff"}[chunkId] + ".chunk.js";
};